import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { AlertTriangle } from "lucide-react";
import { NeuCard, NeuInput } from "../components/neu/Neu";
import { SalesShell } from "../features/sales/SalesShell";
import { CustomerForm } from "../features/sales/CustomerForm";
import { listCustomers } from "../api/sales";
import { localName } from "../lib/localName";

export default function SalesCustomersPage() {
  const { t } = useTranslation();
  const [rows, setRows] = useState([]);
  const [search, setSearch] = useState("");

  const load = useCallback(async (term) => {
    const data = await listCustomers(term ? { search: term } : {});
    setRows(data.items || []);
  }, []);

  useEffect(() => {
    load(search);
  }, [load, search]);

  return (
    <SalesShell titleKey="customers">
      <CustomerForm onSaved={() => load(search)} />

      <NeuInput data-testid="customer-search" placeholder={t("sales.searchCustomers")}
                value={search} onChange={(e) => setSearch(e.target.value)} />

      <div className="grid gap-2" data-testid="sales-customer-list">
        {rows.map((row) => (
          <NeuCard key={row.id} className="flex flex-wrap items-center gap-3 p-4"
                   data-testid={`sales-customer-${row.id}`}>
            <span className="min-w-0 flex-1 truncate text-sm font-bold">
              {localName(row)}
            </span>
            <span className="text-[11px] text-muted-foreground">
              {t(`sales.customerType.${row.customer_type}`)}
            </span>
            <span className="font-mono text-[11px] text-muted-foreground num">
              {row.tax?.trn || t("sales.noTrn")}
            </span>
            <span className="font-mono text-sm font-bold num">
              {row.credit?.limit} {row.currency}
            </span>
            {row.credit?.blocked ? (
              <AlertTriangle className="h-4 w-4 text-destructive" data-testid={`blocked-${row.id}`} />
            ) : null}
          </NeuCard>
        ))}
        {!rows.length ? (
          <p className="text-sm text-muted-foreground" data-testid="no-customers">{t("sales.noCustomers")}</p>
        ) : null}
      </div>
    </SalesShell>
  );
}
